import { logger } from '@lib/utils'

import { initialChatState } from './constants'
import {
  onBackgroundConversationUpdateError,
  onBackgroundConversationUpdateStart,
  onBackgroundConversationUpdateSuccess,
  onCleanMessages,
  onExistMessageReceived,
  onExistThreadEventCaptured,
  onFetchInitialStateSuccess,
  onFetchListChunkSuccess,
  onFetchMessagesError,
  onFetchMessagesStart,
  onFetchMessagesSuccess,
  onFetchTranslatedMessagesSuccess,
  onJoinConversationError,
  onJoinConversationStart,
  onJoinConversationSuccess,
  onOpenConversation,
  onRefreshACSToken,
  onSendMessageError,
  onSendMessageStart,
  onSendMessageSuccess,
  onMessageUpdated,
  onSetSuggestedActionStatus,
} from './reducers'

import { onUnknownThreadEventCaptured } from './reducers/onUnknownThreadEventCaptured'
import { ChatReducer, ChatState } from './types'

export const chatReducer: ChatReducer = (
  state = initialChatState,
  action
): ChatState => {
  const { type, ...props } = action
  logger(type, props)

  switch (action.type) {
    case 'FETCH_INITIAL_STATE_START':
      return {
        ...state,
        fetching: 'PENDING',
      }

    case 'FETCH_INITIAL_STATE_ERROR':
      return {
        ...state,
        fetching: 'ERROR',
        fetchInitialStateErrorStatus: action.payload.status,
      }

    case 'FETCH_LIST_CHUNK_ERROR':
      return {
        ...state,
        fetchingListChunk: 'ERROR',
      }

    case 'FETCH_LIST_CHUNK_START':
      return {
        ...state,
        fetchingListChunk: 'PENDING',
      }

    case 'FETCH_INITIAL_STATE_SUCCESS':
      return {
        ...onFetchInitialStateSuccess(state, action.payload),
        fetchInitialStateErrorStatus: undefined,
      }

    case 'SET_CONVERSATIONS_LIST_STATUS':
      return {
        ...state,
        status: action.payload,
      }

    case 'SET_REPLY_DETECTION_STATUS':
      return {
        ...state,
        replyDetectionStatus: action.payload,
      }

    case 'REFRESH_ACS_TOKEN_SUCCESS':
      return onRefreshACSToken(state, action.payload)

    case 'FETCH_LIST_CHUNK_SUCCESS':
      return onFetchListChunkSuccess(state, action.payload)

    case 'JOIN_CONVERSATION_START':
      return onJoinConversationStart(state, action.payload)

    case 'JOIN_CONVERSATION_ERROR':
      return onJoinConversationError(state, action.payload)

    case 'JOIN_CONVERSATION_SUCCESS':
      return onJoinConversationSuccess(state, action.payload)

    case 'OPEN_CONVERSATION':
      return onOpenConversation(state, action.payload)

    case 'SEND_MESSAGE_START':
      return onSendMessageStart(state, action.payload)

    case 'SEND_MESSAGE_ERROR':
      return onSendMessageError(state, action.payload)

    case 'SEND_MESSAGE_SUCCESS':
      return onSendMessageSuccess(state, action.payload)

    case 'FETCH_MESSAGES_ERROR':
      return onFetchMessagesError(state, action.payload)

    case 'FETCH_MESSAGES_START':
      return onFetchMessagesStart(state, action.payload)

    case 'FETCH_MESSAGES_SUCCESS':
      return onFetchMessagesSuccess(state, action.payload)

    case 'FETCH_TRANSLATED_MESSAGES_SUCCESS':
      return onFetchTranslatedMessagesSuccess(state, action.payload)

    case 'EXIST_THREAD_EVENT_CAPTURED':
      return onExistThreadEventCaptured(state, action.payload)

    case 'EXIST_MESSAGE_RECEIVED':
      return onExistMessageReceived(state, action.payload)

    case 'UNKNOWN_THREAD_EVENT_CAPTURED':
      return onUnknownThreadEventCaptured(state, action.payload)

    case 'CLEAN_MESSAGES':
      return onCleanMessages(state, action.payload)

    case 'BACKGROUND_CONVERSATION_UPDATE_ERROR':
      return onBackgroundConversationUpdateError(state, action.payload)

    case 'BACKGROUND_CONVERSATION_UPDATE_START':
      return onBackgroundConversationUpdateStart(state, action.payload)

    case 'BACKGROUND_CONVERSATION_UPDATE_SUCCESS':
      return onBackgroundConversationUpdateSuccess(state, action.payload)

    case 'MESSAGE_UPDATED':
      return onMessageUpdated(state, action.payload)

    case 'SET_SUGGESTED_ACTION_STATUS':
      return onSetSuggestedActionStatus(state, action.payload)

    default:
      return state
  }
}
